export { default as Badge, type BadgeProps } from './Badge';
